import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  type?: 'vertical' | 'horizontal';
}

const UploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  type,
}) => {
  const aspectRatio = type === 'vertical' ? 400 / 510 : 1078 / 710;
  const settingsApplied = getWatermarkTag(image) !== 'none';

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
      showText={false}
      showPreview={false}
      aspectRatio={aspectRatio}
      imgRatioX={53}
      imgRatioY={67}
    />
  );
};

export default memo(UploadedImageRow);
